import {
	TenantStatusEnum,
	TenantTypeEnum
}                                   from '@app/modules/admin-tenant/models/tenant.model';
import { CalendarModeEnum }         from '@shared/components/date-picker/date-picker.model';
import { SortOrderEnum }            from '@shared/list-operations/components/sort-filter/sort-filter.model';
import { LIST_OPERATIONS_METADATA } from '@shared/list-operations/config/list-operations.config';
import {
	FilterIdentifiersEnum,
	FilterTypes
}                                   from '@shared/list-operations/model/filter.model';
import {
	IListOperationsConfig,
	ListOperationsIdentifierEnum
}                                   from '@shared/list-operations/model/list-operations.model';
import { PagingModeEnum }           from '@shared/list-operations/model/paging.model';

export const TENANTS_BY_CONTRACT_LIST_OPERATIONS_CONFIG: IListOperationsConfig = {
	id: ListOperationsIdentifierEnum.CONTRACTS_DETAIL_PAGE_TENANTS_TAB_LIST,
	pagingData: {
		mode: PagingModeEnum.Light,
		continuesPagesMode: false,
		defaultValues: {
			pageSize: LIST_OPERATIONS_METADATA.default.paging.pageSize ?? 20,
			pageNumber: LIST_OPERATIONS_METADATA.default.paging.pageNumber ?? 0
		}
	},
	searchData: {
		placeholderI18nPath: 'tenant.search.placeholder'
	},
	sortData: [
		{ name: 'name', i18nPath: 'shared.forms.name.label' },
		{ name: 'type', i18nPath: 'shared.forms.type.label' },
		{ name: 'customerIdentifier', i18nPath: 'shared.forms.customerIdentifier.label' },
		{ name: 'lastModifiedDate', i18nPath: 'shared.forms.lastModifiedDate.label', defaultActive: true, sortOrder: SortOrderEnum.DESC },
		{ name: 'status', i18nPath: 'shared.forms.status.label' }
	],
	filterData: [
		{
			order: 1,
			isRendered: true,
			isDisabled: false,
			filterId: FilterIdentifiersEnum.FILTER,
			type: FilterTypes.FILTER_TEXT_TYPE,
			i18nPath: 'tenant.filter.queryFilter',
			items: [
				{ i18nPath: 'tenant.filter.queryFilter' }
			]
		},
		{
			order: 2,
			isRendered: true,
			isDisabled: false,
			filterId: FilterIdentifiersEnum.STATUS,
			type: FilterTypes.FILTER_LIST_TYPE,
			i18nPath: 'shared.forms.status',
			values: [ TenantStatusEnum.ACTIVE ],
			items: [
				{ value: TenantStatusEnum.ACTIVE, i18nPath: 'shared.status.active' },
				{ value: TenantStatusEnum.DISABLED, i18nPath: 'shared.status.disabled' }
			]
		},
		{
			order: 3,
			isRendered: true,
			isDisabled: false,
			filterId: FilterIdentifiersEnum.TYPE,
			type: FilterTypes.FILTER_LIST_TYPE,
			i18nPath: 'tenant.filter.type',
			values: [ TenantTypeEnum.MANAGED, TenantTypeEnum.STANDARD ],
			items: [
				{ value: TenantTypeEnum.ADMIN, i18nPath: 'shared.tenantType.admin.name' },
				{ value: TenantTypeEnum.INTERNAL, i18nPath: 'shared.tenantType.internal.name' },
				{ value: TenantTypeEnum.DISTRIBUTOR, i18nPath: 'shared.tenantType.distributor.name' },
				{ value: TenantTypeEnum.MANAGED, i18nPath: 'shared.tenantType.managed.name' },
				{ value: TenantTypeEnum.PARTNER, i18nPath: 'shared.tenantType.partner.name' },
				{ value: TenantTypeEnum.RESELLER, i18nPath: 'shared.tenantType.reseller.name' },
				{ value: TenantTypeEnum.STANDARD, i18nPath: 'shared.tenantType.standard.name' },
				{ value: TenantTypeEnum.TEST, i18nPath: 'shared.tenantType.test.name' },
				{ value: TenantTypeEnum.TRIAL, i18nPath: 'shared.tenantType.trial.name' }
			]
		},
		{
			order: 4,
			isRendered: true,
			isDisabled: false,
			filterId: FilterIdentifiersEnum.CONTRACT_MONTH,
			service: 'contractMonth',
			type: FilterTypes.FILTER_DATE_PICKER_TYPE,
			i18nPath: 'contract.tenants.contractMonth',
			values: [ new Date() ],
			properties: {
				calendarMode: CalendarModeEnum.MONTH,
				dateInputFormat: { month: 'long', year: 'numeric' },
				minDate: new Date( 2020, 0 ) // from January 2020
			}
		}
	]
};
